export default __webpack_public_path__ + "static/media/terrafinder.150e140e.mp4";